import { Room } from './skill-details.types';

export const calculatePopularityScore = (room: Room): number => room?.noVotes;

export const sortRooms = (rooms: Room[] | undefined, order: string | undefined): Room[] => {
  if (!rooms) return [];

  const roomsToSort = [...rooms];

  switch (order) {
    case 'newest': {
      return roomsToSort.sort((a, b) => {
        if (!a.created || !b.created) return 0;
        try {
          return new Date(b.created).getTime() - new Date(a.created).getTime();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error parsing dates:', error);
          return 0;
        }
      });
    }
    case 'popular': {
      return roomsToSort.sort((a, b) => calculatePopularityScore(b) - calculatePopularityScore(a));
    }
    case 'duration-asc': {
      return roomsToSort.sort((a, b) => (a.timeToComplete || 0) - (b.timeToComplete || 0));
    }
    case 'duration-desc': {
      return roomsToSort.sort((a, b) => (b.timeToComplete || 0) - (a.timeToComplete || 0));
    }
    case 'a-z': {
      return roomsToSort.sort((a, b) => a.title.localeCompare(b.title));
    }
    case 'z-a': {
      return roomsToSort.sort((a, b) => b.title.localeCompare(a.title));
    }
    default: {
      return roomsToSort;
    }
  }
};
